export const CO2 = () => (
  <abbr title="Carbon Dioxide">
    CO<sub>2</sub>
  </abbr>
);
